import React from 'react';
import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  CardActions,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import { AutoFocusedForm, required, TextField } from 'components';
import { Field } from 'react-final-form';
import { MutableButton } from 'ui/MutableButton';
import { RedButton } from 'components/Buttons';
import { useUserPasswordForm } from './useUserPasswordForm';
import { User } from 'schema';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    header: {
      fontWeight: 'bolder',
    },
    divider: {},
    content: {
      margin: '10px',
    },
    actions: {
      justifyContent: 'flex-end',
    },
    accessButton: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.success.dark,
      '&:hover': {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.light,
      },
    },
  })
);

export interface ChangeUserPasswordProps {
  onClose: () => void;
  user: User;
}

export const ChangeUserPasswordForm = ({ onClose, user }: ChangeUserPasswordProps) => {
  const styles = useStyles();

  const { onSubmit, initialValues, loading } = useUserPasswordForm(onClose, user);
  return (
    <AutoFocusedForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      subscription={{
        submitError: true,
      }}
      render={({ handleSubmit, pristine }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card className={styles.root}>
              <CardHeader title="Измененние пароля" />
              <Divider className={styles.divider} />
              <CardContent className={styles.content}>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="password"
                      label="Введите новый пароль"
                      type="password"
                      component={TextField}
                      validate={required}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="repeatPassword"
                      label="Подтвердите новый пароль"
                      type="password"
                      component={TextField}
                      validate={required}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className={styles.actions}>
                <MutableButton
                  loading={loading}
                  color="primary"
                  disabled={pristine}
                  size="medium"
                  type="submit"
                  variant="contained"
                  className={styles.accessButton}
                >
                  Сохранить
                </MutableButton>
                <RedButton
                  onClick={onClose}
                  disabled={loading}
                  size="medium"
                  type="button"
                  variant="contained"
                >
                  Отмена
                </RedButton>
              </CardActions>
            </Card>
          </form>
        );
      }}
    />
  );
};
